export function getDescricaoPeriodicidade(periodicidade) {
    switch (periodicidade) {
        case "U" : return "Único";
        case "D" : return "Diário";
        case "S" : return "Semanal";
        case "M" : return "Mensal";
        case "A" : return "Anual";
        case "V" : return "Dias Antes do Vencimento";
        case "VD": return "Dias Antes do Vencimento (Pelo Documento)";
        default  : return "Indefinido";
    }
}
